import React, { Component } from 'react'

class RadioButton extends Component {
    render() {
        return (
            <React.Fragment>
                {this.props.data.map((item) => {
                    let checked = false;
                    if (item.value === this.props.initial) {
                        checked = true;
                    }
                    return (
                        <div
                            onClick={() => this.props.onChange(item.value)}
                            className="custom-control custom-radio">
                            <input
                                {...this.props}
                                checked={checked}
                                type="radio"
                                className="custom-control-input" />
                            <label className="custom-control-label">{item.label}</label>
                        </div>
                    )
                })}
            </React.Fragment>
        )
    }
}

RadioButton.defaultProps = {
    initial: undefined,
    data: [],
    onChange(text) { }
}

export default RadioButton;


// WEBPACK FOOTER //
// ./src/components/RadioButton.js